(function (root, factory) {
  'use strict';
  const api = factory();
  if (typeof module === 'object' && module.exports) module.exports = api;
  else api.mount(root);
})(typeof window === 'undefined' ? null : window, function () {
  'use strict';
  function decision(policy, subtotal, wholesale, currency) {
    if (currency !== policy.currency) return {kind: 'quote'};
    if (!Number.isSafeInteger(subtotal) || subtotal < 0) throw new Error('Invalid cart total');
    if (subtotal >= policy.quoteFromCents) return {kind: 'quote'};
    if (wholesale && subtotal < policy.wholesaleMinimumCents) return {kind: 'minimum', remaining: policy.wholesaleMinimumCents - subtotal};
    if (!wholesale) return {kind: 'rate', cents: subtotal >= policy.retailFreeFromCents ? 0 : policy.retailShippingCents};
    const band = policy.bands.find(row => row[0] <= subtotal && subtotal <= row[1]);
    if (!band) throw new Error('No freight band');
    return {kind: 'rate', cents: band[2]};
  }
  function basketText(cart, legacy) {
    if (!cart || !Array.isArray(cart.items) || !cart.items.length) return '';
    const lines = cart.items.map(item => {
      const product = item.product || {};
      const sku = item.sku || product.sku || item.productCode || '';
      const title = item.product_title || item.title || product.name || item.name || '';
      const variant = item.variant_id || item.variantId || '';
      if (!sku && !title && !variant) return JSON.stringify(item);
      return `${item.quantity} × ${title} | SKU: ${sku}${variant ? ' | Variant: ' + variant : ''}`;
    });
    if (!legacy && Number.isSafeInteger(cart.total_price) && cart.currency) {
      lines.push('Merchandise subtotal: ' + new Intl.NumberFormat('en-US', {style:'currency',currency:cart.currency}).format(cart.total_price / 100));
    }
    lines.push('Please confirm products, quantities, discounts, availability and freight before payment.');
    return lines.join('\n');
  }
  async function mount(win) {
    const doc = win.document, node = doc.getElementById('ib-shipping-context');
    if (!node) return;
    const context = JSON.parse(node.textContent);
    const quoteForm = doc.getElementById('FreightQuoteForm');
    const basket = doc.getElementById('FreightBasket');
    let edited = Boolean(quoteForm && quoteForm.querySelector('.ib-freight__errors'));
    if (basket) basket.addEventListener('input', () => { edited = true; });
    const status = doc.querySelector('[data-quote-cart-status]');
    const money = cents => new Intl.NumberFormat(doc.documentElement.lang || 'en-US', {style:'currency',currency:'USD'}).format(cents / 100);
    async function readCart() {
      if (context.legacyBuyer) {
        if (!win.spark || typeof win.spark.getCart !== 'function') throw new Error('Wholesale basket unavailable');
        return win.spark.getCart();
      }
      const response = await win.fetch(context.cartUrl + '.js', {headers:{Accept:'application/json'},cache:'no-store'});
      if (!response.ok) throw new Error('Cart unavailable');
      const cart = await response.json();
      if (!Array.isArray(cart.items) || !Number.isSafeInteger(cart.total_price)) throw new Error('Cart unavailable');
      return cart;
    }
    async function fillBasket() {
      if (!basket || edited) return;
      try {
        const cart = await readCart(), text = basketText(cart, context.legacyBuyer);
        if (edited) return;
        if (text) basket.value = text;
        if (status) status.textContent = text ? 'Your current basket is included. Please check it before sending; you can edit the details.' : 'Your basket is empty. Enter the SKUs and quantities you would like us to quote.';
      } catch (_) {
        if (status) status.textContent = 'We could not load your current basket. Please enter your SKUs and quantities below, or return to your cart and try again.';
      }
    }
    if (quoteForm) {
      await fillBasket();
      if (context.legacyBuyer) doc.addEventListener('sparklayer:ready', fillBasket, {once:true});
      const success = doc.querySelector('[data-quote-success]');
      if (success) success.focus();
    }
    // SparkLayer owns its separate cart. Never substitute the Shopify retail
    // cart or change SparkLayer checkout while the legacy theme stays published.
    if (context.legacyBuyer) return;
    let policy;
    try {
      const response = await win.fetch(context.policyUrl, {cache:'no-cache'});
      if (!response.ok) throw new Error('Policy unavailable');
      policy = await response.json();
      if (policy.currency !== 'USD' || policy.quoteFromCents !== 200000 || !Array.isArray(policy.bands)) throw new Error('Invalid policy');
    } catch (_) { return; }
    const selector = '[data-cart-checkout-button], [data-cart-page-checkout-button], button[name="checkout"]';
    const originalButtons = new WeakMap();
    let latest = {total_price: context.subtotal, currency: context.currency};
    function update(cart) {
      latest = cart;
      let state;
      try { state = decision(policy, cart.total_price, context.nativeBuyer, cart.currency); } catch (_) { return; }
      doc.querySelectorAll(selector).forEach(button => {
        const labelNode = button.querySelector('[data-button-text]') || button;
        if (!originalButtons.has(button)) originalButtons.set(button, {label:labelNode.textContent.trim(), aria:button.getAttribute('aria-label')});
        const original = originalButtons.get(button);
        const label = state.kind === 'quote' ? 'Request freight quote' : original.label;
        if (labelNode.textContent.trim() !== label) labelNode.textContent = label;
        if (state.kind === 'quote') button.setAttribute('aria-label', label);
        else if (original.aria !== null) button.setAttribute('aria-label', original.aria);
        else button.removeAttribute('aria-label');
        let note = button.parentElement.querySelector('[data-ib-cart-shipping-note]');
        if (!note) { note = doc.createElement('div'); note.className = 'ib-cart-shipping-note'; note.dataset.ibCartShippingNote = ''; note.setAttribute('role','status'); button.before(note); }
        let message;
        if (state.kind === 'quote') message = 'We’ll review freight before payment. Your basket stays with you.';
        else if (state.kind === 'minimum') message = 'Add ' + money(state.remaining) + ' to reach the $150 wholesale minimum after discounts.';
        else if (context.nativeBuyer) message = 'Standard freight: ' + money(state.cents) + ' for the contiguous US and DC. Final amount is confirmed at checkout.';
        else message = state.cents === 0 ? 'Your cart qualifies for free standard shipping in the contiguous US and DC.' : '$8.95 standard shipping in the contiguous US and DC. Add ' + money(Math.max(0,policy.retailFreeFromCents - cart.total_price)) + ' for free shipping.';
        if (note.dataset.message !== message) {
          note.dataset.message = message; note.replaceChildren(doc.createTextNode(message + ' '));
          const link = doc.createElement('a'); link.href = context.quoteUrl; link.textContent = 'Other destinations? Request a quote.'; note.append(link);
        }
      });
    }
    update(latest);
    let refreshing = false, timer;
    async function refresh() {
      if (refreshing) return;
      refreshing = true;
      try { update(await readCart()); } catch (_) { /* Keep the server-rendered policy link available. */ }
      finally { refreshing = false; }
    }
    const cartSelector = 'cart-page, cart-drawer, form[action*="/cart"]';
    const observer = new win.MutationObserver(records => {
      if (!doc.querySelector(selector)) return;
      if (!records.some(record => (record.target.closest && record.target.closest(cartSelector)) || Array.from(record.addedNodes).some(added => added.querySelector && (added.matches(cartSelector) || added.matches(selector) || added.querySelector(selector))))) return;
      win.clearTimeout(timer); timer = win.setTimeout(refresh, 180);
    });
    observer.observe(doc.body, {childList:true,subtree:true});
    const approved = new WeakSet();
    let checking = false;
    doc.addEventListener('submit', async event => {
      const form = event.target, submitter = event.submitter;
      if (!submitter || !submitter.matches(selector)) return;
      if (approved.has(form)) { approved.delete(form); return; }
      event.preventDefault(); event.stopImmediatePropagation();
      if (checking) return;
      checking = true;
      try {
        const cart = await readCart(); update(cart);
        const state = decision(policy, cart.total_price, context.nativeBuyer, cart.currency);
        if (state.kind === 'quote') win.location.assign(context.quoteUrl);
        else if (state.kind === 'rate') { approved.add(form); form.requestSubmit(submitter); }
      } catch (_) {
        const note = submitter.parentElement.querySelector('[data-ib-cart-shipping-note]');
        if (note) note.textContent = 'We couldn’t verify your basket. Please refresh and try again, or use Shipping & freight quotes above.';
      } finally { checking = false; }
    }, true);
    doc.addEventListener('click', async event => {
      const link = event.target.closest && event.target.closest('a[href]');
      if (!link || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      const target = new URL(link.href, win.location.href);
      if (target.origin !== win.location.origin || !/\/checkout\/?$/.test(target.pathname)) return;
      event.preventDefault(); event.stopImmediatePropagation();
      if (checking) return;
      checking = true;
      try {
        const cart = await readCart(); update(cart);
        const state = decision(policy, cart.total_price, context.nativeBuyer, cart.currency);
        win.location.assign(state.kind === 'quote' ? context.quoteUrl : state.kind === 'minimum' ? context.cartUrl : link.href);
      } catch (_) { win.location.assign(context.cartUrl); }
      finally { checking = false; }
    }, true);
    return {update,refresh,observer};
  }
  return {decision,basketText,mount};
});
